export default __webpack_public_path__ + "static/media/mail.87f71d00.svg";